import { Injectable } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { BoxxUtilsService } from './BoxxUtils.service';
import { BottomSheetType } from '@app/components/bottom-sheet/bottom-sheet.model';
import { BoxxImageConstraints } from '@boxx/boxx-images/lib/models/BoxxImage.model';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { BoxxImageFixerComponent } from '@boxx/boxx-images/lib/components/image-fixer/invalid-images-fixer.component';
import { PixabaySelectComponent } from '@app/pages/settings/components/pixabay-picker/pixabay-select.component';

@Injectable()
export class ImageUtilsService {
  private isMobileDevice = false;
  private isIos = false;
  private translations: any;
  private destroyed$ = new Subject<boolean>();

  promiseResolve: (
    value: any[] | PromiseLike<any[]> | number
  ) => void;

  promisePixaBayResolve: (
    value: any
  ) => void;

  promiseReject: (reason?: any) => void;

  constructor(
    public platform: Platform,
    public translate: TranslateService,
    public boxxUtils: BoxxUtilsService,
    private modalCtrl: ModalController
  ) {
    platform.ready().then(() => {
      this.isMobileDevice = platform
        .platforms()
        .some((p) => ['cordova', 'capacitor'].includes(p));

      this.isIos = platform
        .platforms()
        .some((name) => ['ios', 'ipad', 'iphone'].includes(name));
    });

    translate
      .get(['BUSINESS_FORMS', 'ACTIONS', 'ERRORS', 'SUCCESS'])
      .pipe(takeUntil(this.destroyed$))
      .subscribe((t) => (this.translations = t));
  }

  async showImagePickerSources(hideOptionCamera?: boolean, modalTitle?: string): Promise<number> {
    let _showCameraOption = (hideOptionCamera !== undefined) ? hideOptionCamera : true;
    let _customModalTitle = (modalTitle !== undefined) ? modalTitle : 'BUSINESS_FORMS.WEBPAGE.ACTION_SHEET.header';
    console.log('_showCameraOption: ', _showCameraOption);
    return new Promise(async (resolve) => {
      let dataPicker = [
        {
          key: '1',
          value: 'BUSINESS_FORMS.WEBPAGE.ACTION_SHEET.BUTTONS.fromDeviceText',
          icon: 'image',
          icon_type: 'name',
          class: 'custom'
        },
        {
          key: '3',
          value: 'BUSINESS_FORMS.WEBPAGE.ACTION_SHEET.BUTTONS.fromPixabay',
          icon: 'search',
          icon_type: 'name',
          class: 'custom'
        }
      ];

      if (this.isMobileDevice && !hideOptionCamera) {
        dataPicker.push(
          {
            key: '4',
            value: 'BUSINESS_FORMS.WEBPAGE.ACTION_SHEET.BUTTONS.takePhoto',
            icon: 'camera',
            icon_type: 'name',
            class: 'custom'
          }
        );
      }

      this.boxxUtils.openBottomSheet({
        data: dataPicker,
        type: BottomSheetType.options,
        initialBreakpoint: 1,
        breakpoints: [0, 1],
        canClose: true,
        title: _customModalTitle,
        maxHeigth: 30
      }).then((data) => {
        if (data?.value) {
          resolve(Number(data?.value));
        }
      });
    });
  }

  validateAndFixImages(images: any[], constraints: ImageDimensionsProps, _isUrl: boolean): Promise<any[]> {
    return new Promise(async (resolve) => {
      if (images.some(img => !img.validations.valid)) {
        const view = await this.modalCtrl.create({
          component: BoxxImageFixerComponent,
          componentProps: {
            boxxImages: images,
            constraints,
            isUrl: _isUrl
          },
        });

        view.present();

        const { data } = await view.onDidDismiss();
        return resolve(data.images);
      } else {
        return resolve(images);
      }
    });
  }

  // async pickerFromPixaBay(imageConstraints: BoxxImageConstraints, maxImages: number): Promise<any[]> {
  //   return new Promise(async (resolve) => {
  //     const maxBytes = 5 * 1000 * 1000
  //     const view = await this.modalCtrl.create({
  //       component: PixabaySelectComponent,
  //       componentProps: {
  //         maxImages
  //       }
  //     });

  //     view.present();

  //     const { data } = await view.onDidDismiss();

  //     if (data === undefined) {
  //       return resolve([]);
  //     }
  //     console.log('data modal:', data);
  //     let arrayImages: any[];

  //     arrayImages = [];
  //     data.pixabayImages.map(async (img) => {
  //       const base64Image = await this.convertImageToBase64(img.largeImageURL);
  //       arrayImages.push({
  //         bytes: img.imageSize, //in bytes
  //         dimensions: {
  //           width: img.imageWidth,
  //           height: img.imageHeight,
  //           aspectRatio: 1
  //         },
  //         content: base64Image, //img.largeImageURL,
  //         path: img.largeImageURL,
  //         validations: {
  //           width: {
  //             maxWidth: imageConstraints.maxWidth,
  //             valid: (img.imageWidth <= imageConstraints.maxWidth) ? true : false
  //           },
  //           height: {
  //             maxHeight: imageConstraints.maxHeight,
  //             valid: (img.imageHeight <= imageConstraints.maxHeight) ? true : false
  //           },
  //           aspectRatio: {
  //             ratio: imageConstraints.aspectRatio,
  //             valid: false
  //           },
  //           bytes: {
  //             maxBytes: maxBytes,
  //             valid: (img.imageSize <= maxBytes) ? true : false
  //           },
  //           valid: false
  //         }
  //       });
  //     });
  //     // if (arrayImages.length === data.pixabayImages.length) {
  //     //   return resolve(arrayImages);
  //     // }
  //     setTimeout(() => {
  //       return resolve(arrayImages);
  //     }, 8000);
  //     //return data;
  //   });
  // }

// imageToBase64 = (url, callback) => {
//     var xhr = new XMLHttpRequest()
//     xhr.onload = function () {
//         var reader = new FileReader()
//         reader.onloadend = function () {
//             callback(reader.result)
//         }
//         reader.readAsDataURL(xhr.response)
//     }
//     xhr.open('GET', url)
//     xhr.responseType = 'blob'
//     xhr.send()
// }

async pickerFromPixaBay(imageConstraints: BoxxImageConstraints, maxImages: number): Promise<any[]> {
  return new Promise(async (resolve) => {
    const maxBytes = 5 * 1000 * 1000;
    const view = await this.modalCtrl.create({
      component: PixabaySelectComponent,
      componentProps: {
        maxImages
      }
    });

    view.present();

    const { data } = await view.onDidDismiss();

    if (data === undefined) {
      return resolve([]);
    }

    let arrayImages: any[] = [];
    this.boxxUtils.handleLoading(true);
    const imagePromises = data.pixabayImages.map(async (img) => {
      const base64Image = await this.convertImageToBase64(img.largeImageURL);
      arrayImages.push({
        bytes: img.imageSize,
        dimensions: {
          width: img.imageWidth,
          height: img.imageHeight,
          aspectRatio: 1
        },
        content: base64Image,
        path: img.largeImageURL,
        validations: {
          width: {
            maxWidth: imageConstraints.maxWidth,
            valid: (img.imageWidth <= imageConstraints.maxWidth) ? true : false
          },
          height: {
            maxHeight: imageConstraints.maxHeight,
            valid: (img.imageHeight <= imageConstraints.maxHeight) ? true : false
          },
          aspectRatio: {
            ratio: imageConstraints.aspectRatio,
            valid: false
          },
          bytes: {
            maxBytes: maxBytes,
            valid: (img.imageSize <= maxBytes) ? true : false
          },
          valid: false
        }
      });
    });

    await Promise.all(imagePromises);
    this.boxxUtils.handleLoading(false);
    resolve(arrayImages);
  });
}


convertImageToBase64(url: string): Promise<string> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.onload = () => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result as string); // Devuelve el Base64
      };
      reader.onerror = () => reject('Error al leer la imagen');
      reader.readAsDataURL(xhr.response); // Convierte la respuesta en Base64
    };
    xhr.onerror = () => reject('Error en la solicitud de imagen');
    xhr.open('GET', url);
    xhr.responseType = 'blob'; // Obtener la imagen como blob
    xhr.send();
  });
}

// imageToBase64(url: string, callback: (result: string) => void) {
//   var xhr = new XMLHttpRequest();
//   xhr.onload = function () {
//     var reader = new FileReader();
//     reader.onloadend = function () {
//       callback(reader.result as string); // Convertimos el resultado a string
//     };
//     reader.readAsDataURL(xhr.response);
//   };
//   xhr.open('GET', url);
//   xhr.responseType = 'blob';
//   xhr.send();
// }

  async pickerFromDevice(imageConstraints: BoxxImageConstraints, maxImages: number): Promise<any[]> {
    return new Promise(async (resolve) => {
      const maxBytes = 5 * 1000 * 1000
      let arrayImages: any[];
      const images: any = await Camera.pickImages({
        quality: 30,
        limit: maxImages,

      });

      if (images && images.photos !== null) {
        arrayImages = [];
        for (let i = 0; i < images.photos.length; i++) {
          const response = await fetch(images.photos[i].webPath);
          const blob = await response.blob();
          const _newBaseImage = await this.convertBlobToBase64(blob) as string;
          //console.log('_newBaseImage:', _newBaseImage);
          var _file = new File([blob], 'image_' + i);
          //console.log('_file: ', _file);

          var url = URL.createObjectURL(_file);
          var img = new Image;

          img.onload = function () {
            //console.log('img.width:', img.width);

            arrayImages.push({
              bytes: _file.size, //in bytes
              dimensions: {
                width: img.width,
                height: img.height,
                aspectRatio: 1
              },
              content: _newBaseImage,
              path: images.photos[i].webPath,
              validations: {
                width: {
                  maxWidth: imageConstraints.maxWidth,
                  valid: (img.width <= imageConstraints.maxWidth) ? true : false
                },
                height: {
                  maxHeight: imageConstraints.maxHeight,
                  valid: (img.height <= imageConstraints.maxHeight) ? true : false
                },
                aspectRatio: {
                  ratio: imageConstraints.aspectRatio,
                  valid: false
                },
                bytes: {
                  maxBytes: maxBytes,
                  valid: (_file.size <= maxBytes) ? true : false
                },
                valid: false
              }
            });
            URL.revokeObjectURL(img.src);
            if (i === (images.photos.length - 1)) {
              return resolve(arrayImages);
            }
          };

          img.src = url;

        }
      }
      else {
        return resolve([]);
      }
    });
  }

  async pickerFromCamera(imageConstraints: BoxxImageConstraints): Promise<any[]> {
    return new Promise(async (resolve) => {
      const maxBytes = 5 * 1000 * 1000
      let arrayImages: any[];
      const images: any = await Camera.getPhoto({
        quality: 30,
        allowEditing: false,
        resultType: CameraResultType.Base64,
        source: CameraSource.Camera
      });

      if (images && images.base64String !== undefined) {
        let _newBlob = this.convertBase64ToBlob('data:image/' + images.format + ';base64,' + images.base64String);
        arrayImages = [];
        //const response = await fetch(images.photos[i].webPath);
        //const blob = await response.blob();
        const _newBaseImage = await this.convertBlobToBase64(_newBlob) as string;
        //console.log('_newBaseImage:', _newBaseImage);
        var _file = new File([_newBlob], 'photo_1');
        //console.log('_file: ', _file);

        var url = URL.createObjectURL(_file);
        var img = new Image;

        img.onload = function () {
          //console.log('img.width:', img.width);

          arrayImages.push({
            bytes: _file.size, //in bytes
            dimensions: {
              width: img.width,
              height: img.height,
              aspectRatio: 1
            },
            content: 'data:image/' + images.format + ';base64,' + images.base64String,
            path: '',
            validations: {
              width: {
                maxWidth: imageConstraints.maxWidth,
                valid: (img.width <= imageConstraints.maxWidth) ? true : false
              },
              height: {
                maxHeight: imageConstraints.maxHeight,
                valid: (img.height <= imageConstraints.maxHeight) ? true : false
              },
              aspectRatio: {
                ratio: imageConstraints.aspectRatio,
                valid: false
              },
              bytes: {
                maxBytes: maxBytes,
                valid: (_file.size <= maxBytes) ? true : false
              },
              valid: false
            }
          });
          URL.revokeObjectURL(img.src);
          setTimeout(() => {
            return resolve(arrayImages);
          }, 1000);
        };

        img.src = url;
      }
      else {
        return resolve([]);
      }
    });
  }

  dataURItoBlob(dataURI) {
    var byteString = atob(dataURI.split(',')[1]);

    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

    // write the bytes of the string to an ArrayBuffer
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    // write the ArrayBuffer to a blob, and you're done
    var bb = new Blob([ab]);
    return bb;
  }

  convertBlobToBase64 = (blob: Blob) => new Promise((resolve, reject) => {
    const reader = new FileReader;
    reader.onerror = reject;
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.readAsDataURL(blob);
  });

  convertBase64ToBlob(dataURI) {

    var byteString = atob(dataURI.split(',')[1]);
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);

    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    var blob = new Blob([ab], { type: mimeString });

    return blob;
  }

  clearBase64Images(base64Image: string) {
    const divisiones = base64Image.split(';');
    const mimeType = divisiones[0].split('/');
    const imageBase64Clear = base64Image.replace(
      'data:image/' + mimeType[1] + ';base64,',
      ''
    );
    return imageBase64Clear;
  }

  // getImgFileSize(imageUri: string): Promise<number> {
  //   return new Promise((resolve, reject) => {
  //     if (imageUri.startsWith('data:image')) {
  //       const contentWithoutMime = imageUri.split(',')[1];
  //       const sizeInBytes = window.atob(contentWithoutMime).length;
  //       return resolve(sizeInBytes);
  //     }

  //     this.file
  //       .resolveLocalFilesystemUrl(imageUri)
  //       .then((fileEntry) => {
  //         fileEntry.getMetadata(
  //           (fileObj) => {
  //             const size = fileObj.size;
  //             resolve(size);
  //           },
  //           (e) => {
  //             console.error(
  //               '**** getImgFileSize() -> fileEntry.getMetadata()',
  //               e
  //             );
  //             reject(e);
  //           }
  //         );
  //       })
  //       .catch((e) => {
  //         console.error(
  //           '**** getImgFileSize() -> file.resolveLocalFilesystemUrl()',
  //           e
  //         );
  //         reject(e);
  //       });
  //   });
  // }

  getImgDimensions(imageUri: any): Promise<{ width: number; height: number }> {
    return new Promise((resolve, reject) => {
      let img = new Image();

      img.onload = (_) => {
        resolve({ width: img.width, height: img.height });
        img = null;
      };

      img.onerror = (e) => {
        reject(e);
        img = null;
      };

      img.src = imageUri;
    });
  }

  getImgBase64Dimensions(
    data: string
  ): Promise<{ width: number; height: number }> {
    return new Promise((resolve, reject) => {
      let img = new Image();

      img.onload = (_) => {
        resolve({ width: img.width, height: img.height });
        img = null;
      };

      img.onerror = (e) => {
        reject(e);
        img = null;
      };

      img.src = data;
    });
  }

  imgDataUriToBase64(
    imageUri: string,
    outputFormat = 'image/jpeg'
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      if (!imageUri) {
        return reject('Image URI must not be null/empty');
      }
      if (!outputFormat) {
        return reject('Image output format must not be null/empty');
      }

      let img = new Image();
      img.crossOrigin = 'Anonymous';

      img.onload = () => {
        let c = document.createElement('canvas') as HTMLCanvasElement;
        const ctx = c.getContext('2d');
        c.width = img.width;
        c.height = img.height;
        ctx.drawImage(img, 0, 0);
        const dataURL = c.toDataURL(outputFormat);
        c = null;
        resolve(dataURL);
        img = null;
      };

      img.onerror = (e) => {
        console.error('*** imgDataUriToBase64 ERROR:', e);

        reject(e);
        img = null;
      };

      imageUri = imageUri.replace('unsafe:', '');

      img.src = (window as any).Ionic.WebView.convertFileSrc(imageUri);
    });
  }

  openBrowserFilePicker(options?: {
    type?: string;
    accept?: string;
    multiple?: boolean;
  }): Promise<
    | {
      status: 'success' | 'error';
      data: IBrowserImageDataProps;
    }[]
    | undefined
  > {
    const pickerOptions = {
      type: 'file',
      accept: 'image/jpg',
      multiple: true,
      ...options,
    };

    const input = document.createElement('input');
    input.type = pickerOptions.type;
    input.accept = pickerOptions.accept;
    input.multiple = pickerOptions.multiple;

    return new Promise((resolve) => {
      const promises: Promise<{
        status: 'success' | 'error';
        data: IBrowserImageDataProps | any;
      }>[] = [];

      input.onchange = (e: any) => {
        const files = e.target.files;

        Object.keys(files).forEach((key) => {
          const reader = new FileReader();
          const file = files[key];
          reader.readAsDataURL(file);

          promises.push(
            new Promise((response) => {
              reader.onload = async (readerEvent) => {
                const content = readerEvent.target.result as string;

                const normalizedImg: IBrowserImageDataProps = {
                  lastModified: file.lastModified,
                  lastModifiedDate: file.lastModifiedDate,
                  name: file.name,
                  size: file.size,
                  type: file.type,
                  dimensions: await this.getImgDimensions(content),
                  content,
                  file,
                };

                return response({ status: 'success', data: normalizedImg });
              };

              reader.onerror = async (readerEvent) =>
                response({ status: 'error', data: readerEvent.target.error });
            })
          );
        });

        return resolve(
          Promise.all(promises).then(
            (resp) =>
              resp
          )
        );
      };
      input.click();
    });
  }

}

export interface ImageDimensionsProps {
  width: number;
  height: number;
  aspectRatio?: number;
}

export interface IBrowserImageDataProps {
  lastModified: number;
  lastModifiedDate: Date;
  name: string;
  size: number;
  type: string;
  dimensions: { width: number; height: number };
  content: string;
  file?: File;
}
